import {
  GQL_GET_SUBSCRIPTION,
  GQL_GET_SUBSCRIPTIONS,
} from "@/graphql/bundle.graphql";
import {
  GetSubsDtoField,
  ISubscription,
  ISubscriptions,
} from "@/interfaces/bundle.interface";
import { Order } from "@/interfaces/common.interface";
import { currentUserState } from "@/stores/common";
import { subscriptionsState, subscriptionState } from "@/stores/subscription";
import { useQuery } from "@apollo/react-hooks";
import { useMemo, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

export const useSubscriptions = ({
  page,
  size,
}: {
  page: number;
  size: number;
}) => {
  const [field, _setField] = useState(GetSubsDtoField.UPDATED_AT);
  const currentUser = useRecoilValue(currentUserState);
  const [subscriptions, setSubscriptions] = useRecoilState(subscriptionsState);
  const { data, loading } = useQuery<
    { getSubscriptions: ISubscriptions },
    {
      gsd: {
        take: number;
        skip: number;
        order?: Order;
        field?: GetSubsDtoField;
      };
    }
  >(GQL_GET_SUBSCRIPTIONS, {
    variables: {
      gsd: {
        skip: (page - 1) * size,
        take: size,
        order: Order.DESC,
        field,
      },
    },
    skip: !currentUser?.id,
  });
  useMemo(() => {
    if (data) {
      setSubscriptions(data?.getSubscriptions);
    }
  }, [data]);
  const setField = (field: GetSubsDtoField) => _setField(field);
  return { loading, setField, field };
};

export const useSubscription = (id: string) => {
  const currentUser = useRecoilValue(currentUserState);
  const [subscription, setSubscription] = useRecoilState(subscriptionState);
  const { data, loading } = useQuery<
    { getSubscription: ISubscription },
    { id: string }
  >(GQL_GET_SUBSCRIPTION, {
    skip: !currentUser.id,
    variables: {
      id,
    },
  });
  useMemo(() => {
    if (data) {
      setSubscription(data?.getSubscription);
    }
  }, [data]);
  return { loading };
};
